// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__tq7ZC","title":"BackImages_title__2Lvp_","images":"BackImages_images__C4XZq"};